import { CalendarOff, Thermometer, Repeat, Banknote, ShoppingCart, HelpCircle, ArrowRightLeft } from 'lucide-react';

/** Druhy žádostí — ikona a název pro seznam i výběr v „Nové žádosti". */
export const DRUHY = {
    volno:   { nazev: 'Volno',          Icon: CalendarOff },
    nemoc:   { nazev: 'Nemoc',          Icon: Thermometer },
    vymena:  { nazev: 'Výměna směny',   Icon: Repeat },
    predani: { nazev: 'Předání směny',  Icon: ArrowRightLeft },
    zaloha:  { nazev: 'Záloha',         Icon: Banknote },
    nakup:   { nazev: 'Nákup',          Icon: ShoppingCart },
    jine:    { nazev: 'Jiné',           Icon: HelpCircle },
};

export const STAVY = {
    ceka:      'Čeká',
    schvaleno: 'Schváleno',
    zamitnuto: 'Zamítnuto',
    zruseno:   'Zrušeno',
};

/** „12. 10." nebo „12.–14. 10." */
export function termin(od, doD) {
    if (!od) return '';
    const a = new Date(od), b = new Date(doD || od);
    const f = (d) => `${d.getDate()}. ${d.getMonth() + 1}.`;
    return a.toDateString() === b.toDateString() ? f(a) : `${f(a)} – ${f(b)}`;
}

export const kc = (n) => (n == null ? '' : `${Number(n).toLocaleString('cs')} Kč`);

/** Cesta API pro akci nad položkou (sjednocené žádosti mají různé zdroje). */
export function cestaAkce(p, akce) {
    if (p.zdroj === 'nepritomnost') {
        if (akce === 'zrusit') return { url: `/api/me/nedostupnosti/${p.id}`, metoda: 'DELETE' };
        return { url: `/api/shifts/nedostupnosti/${p.id}/${akce === 'schvalit' ? 'schvalit' : 'zamitnout'}`, metoda: 'POST' };
    }
    if (p.zdroj === 'prohozeni') {
        const mapa = { prijmout: 'akceptovat', odmitnout: 'odmitnout', admin_schvalit: 'admin-schvalit', admin_zamitnout: 'admin-zamitnout', stornovat: 'stornovat' };
        return { url: `/api/shifts/prohozeni/${p.id}/${mapa[akce]}`, metoda: 'POST' };
    }
    return { url: `/api/zadosti/${p.id}/${akce}`, metoda: 'POST' };
}

export const POPISKY_AKCI = {
    schvalit: 'Schválit', zamitnout: 'Zamítnout', zrusit: 'Stáhnout žádost',
    prijmout: 'Beru', odmitnout: 'Nemůžu', admin_schvalit: 'Schválit', admin_zamitnout: 'Zamítnout', stornovat: 'Stáhnout',
};
export const KLADNE_AKCE = ['schvalit', 'prijmout', 'admin_schvalit'];
